import QRCode from 'qrcode';

/**
 * Modal for configuring slab information with front and back sides
 * Simplified back side to only support optional QR code
 */
export default class SlabModal {
    /**
     * Create a new slab modal
     */
    constructor() {
        this.isVisible = false;
        this.slabData = {
            // Front side data
            textField1: '',
            textField2: '',
            textField3: '',
            textField4: '',
            textField5: '',
            textField6: '',
            
            // Back side data
            backSide: {
                // Static text pre-filled
                textLine1: 'CUSTOM CARD LAB',
                textLine2: '@CUSTOMCARDLAB',
                textLine3: 'ROOKIE AUTO',
                backSerial: 'CCL001',
                hasImage: true,
                imageUrl: '/wp-content/plugins/octo-stc/public/assets/company_logo.webp',
                // QR code is the only editable part
                qrEnabled: false,
                qrContent: '',
                qrDataUrl: null
            }
        };
        this.activeTab = 'front'; // 'front' or 'back'
        this.createModal();
        this.bindEvents();
    }

    /**
     * Create the modal DOM structure
     */
    createModal() {
        this.modal = document.createElement('div');
        this.modal.className = 'stc-slab-modal';
        
        this.modal.innerHTML = `
            <div class="stc-slab-modal-content">
                <div class="stc-slab-modal-header">
                    <h3>Customize Grading Slab</h3>
                    <button class="stc-slab-modal-close">&times;</button>
                </div>
                
                <div class="stc-slab-tabs">
                    <button class="stc-slab-tab active" data-tab="front">Front Side</button>
                    <button class="stc-slab-tab" data-tab="back">Back Side</button>
                </div>
                
                <div class="stc-slab-modal-body">
                    <!-- Front Side Panel -->
                    <div class="stc-slab-panel active" id="stc-slab-front-panel">
                        <div class="stc-slab-form">
                            <div class="stc-slab-input-group">
                                <label for="slab-text-field-1">Text Field 1</label>
                                <input type="text" id="slab-text-field-1" class="stc-slab-input" placeholder="Enter text" maxlength="30">
                            </div>
                            
                            <div class="stc-slab-input-group">
                                <label for="slab-text-field-2">Text Field 2</label>
                                <input type="text" id="slab-text-field-2" class="stc-slab-input" placeholder="Enter text" maxlength="30">
                            </div>
                            
                            <div class="stc-slab-input-group">
                                <label for="slab-text-field-3">Text Field 3</label>
                                <input type="text" id="slab-text-field-3" class="stc-slab-input" placeholder="Enter text" maxlength="20">
                            </div>
                            
                            <div class="stc-slab-input-group">
                                <label for="slab-text-field-4">Text Field 4</label>
                                <input type="text" id="slab-text-field-4" class="stc-slab-input" placeholder="Enter text" maxlength="20">
                            </div>
                            
                            <div class="stc-slab-row">
                                <div class="stc-slab-input-group stc-slab-input-half">
                                    <label for="slab-text-field-5">Text Field 5</label>
                                    <input type="text" id="slab-text-field-5" class="stc-slab-input" placeholder="Enter text" maxlength="20">
                                </div>
                                
                                <div class="stc-slab-input-group stc-slab-input-half">
                                    <label for="slab-text-field-6">Text Field 6</label>
                                    <input type="text" id="slab-text-field-6" class="stc-slab-input" placeholder="Enter text" maxlength="10">
                                </div>
                            </div>
                        </div>
                        
                        <div class="stc-slab-preview">
                            <div class="stc-slab-preview-text">Front Preview</div>
                            <div class="stc-slab-preview-container">
                                <div class="stc-slab-preview-content">
                                    <div class="stc-slab-preview-row">
                                        <div class="stc-slab-preview-field" id="preview-text-field-1">Jeff Gilbert</div>
                                        <div class="stc-slab-preview-field" id="preview-text-field-4">#001</div>
                                    </div>
                                    <div class="stc-slab-preview-row">
                                        <div class="stc-slab-preview-field" id="preview-text-field-2">Custom Card Lab</div>
                                        <div class="stc-slab-preview-field" id="preview-text-field-5">GEM MT</div>
                                    </div>
                                    <div class="stc-slab-preview-row">
                                        <div class="stc-slab-preview-field" id="preview-text-field-3">Est 02-22-2025</div>
                                        <div class="stc-slab-preview-field" id="preview-text-field-6">10</div>
                                    </div>
                                    <div class="stc-slab-preview-barcode" id="preview-barcode"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Back Side Panel (Simplified) -->
                    <div class="stc-slab-panel" id="stc-slab-back-panel">
                        <div class="stc-slab-back-layout">
                            <!-- QR Code Section (Only editable component) -->
                            <div class="stc-slab-back-section">
                                <h4>Custom QR Code (Optional)</h4>
                                <div class="stc-slab-qr-toggle">
                                    <label class="stc-switch">
                                        <input type="checkbox" id="slab-qr-enabled" class="stc-slab-qr-toggle">
                                        <span class="stc-slider"></span>
                                    </label>
                                    <span class="stc-toggle-label">Add Custom QR Code (+$5.00)</span>
                                </div>
                                
                                <div class="stc-slab-input-group stc-slab-qr-content-group" style="display: none;">
                                    <label for="slab-qr-content">QR Code Content</label>
                                    <input type="text" id="slab-qr-content" class="stc-slab-input" placeholder="https://example.com" disabled>
                                    <div class="stc-slab-hint">Enter URL or text for QR code</div>
                                </div>
                                
                                <div class="stc-slab-qr-preview" style="display: none;">
                                    <div id="qr-preview" class="stc-slab-qr-image">
                                        <div class="stc-slab-qr-placeholder">
                                            <span>QR code will appear here</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Back Side Preview -->
                        <div class="stc-slab-back-preview">
                            <div class="stc-slab-preview-text">Back Preview</div>
                            <div class="stc-slab-preview-container">
                                <div class="stc-slab-back-preview-content">
                                    <!-- Left section preview (static text) -->
                                    <div class="stc-slab-back-preview-left">
                                        <div class="stc-slab-back-preview-text" id="preview-back-text1">CUSTOM CARD LAB</div>
                                        <div class="stc-slab-back-preview-text" id="preview-back-text2">@CUSTOMCARDLAB</div>
                                        <div class="stc-slab-back-preview-text" id="preview-back-text3">ROOKIE AUTO</div>
                                        <div class="stc-slab-back-preview-barcode" id="preview-back-barcode"></div>
                                    </div>
                                    
                                    <!-- Middle section preview (static logo) -->
                                    <div class="stc-slab-back-preview-middle" id="preview-back-image">
                                        <img src="/wp-content/plugins/octo-stc/public/assets/company_logo.webp" alt="Custom Card Lab Logo">
                                    </div>
                                    
                                    <!-- Right section preview (QR code) -->
                                    <div class="stc-slab-back-preview-right">
                                        <div class="stc-slab-back-preview-qr" id="preview-back-qr"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="stc-slab-modal-footer">
                    <button class="stc-slab-cancel-btn">Cancel</button>
                    <button class="stc-slab-apply-btn">Apply</button>
                </div>
            </div>
        `;
        
        document.body.appendChild(this.modal);
        this.updatePreview();
        this.loadQRCodeLibrary();
    }
    
    /**
     * Load QR Code library dynamically
     */
    loadQRCodeLibrary() {
        // Check if QRCode is already available globally
        if (typeof QRCode !== 'undefined') {
            return Promise.resolve();
        }
        
        // Otherwise, load it from CDN
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/qrcode@1.5.3/build/qrcode.min.js';
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }
    
    /**
     * Bind event listeners
     */
    bindEvents() {
        // Modal close button
        this.modal.querySelector('.stc-slab-modal-close').addEventListener('click', () => {
            this.hide();
        });
        
        // Tab switching
        this.modal.querySelectorAll('.stc-slab-tab').forEach(tab => {
            tab.addEventListener('click', () => {
                this.switchTab(tab.dataset.tab);
            });
        });
        
        // Cancel button
        this.modal.querySelector('.stc-slab-cancel-btn').addEventListener('click', () => {
            this.hide();
        });
        
        // Apply button
        this.modal.querySelector('.stc-slab-apply-btn').addEventListener('click', () => {
            this.saveData();
            this.hide();
        });
        
        // Bind front side input events
        this.bindFrontSideEvents();
        
        // Bind back side input events (only QR toggle now)
        this.bindBackSideEvents();
        
        // Escape key to close
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isVisible) {
                this.hide();
            }
        });
    }
    
    /**
     * Bind front side input events
     */
    bindFrontSideEvents() {
        const textField1Input = this.modal.querySelector('#slab-text-field-1');
        const textField2Input = this.modal.querySelector('#slab-text-field-2');
        const textField3Input = this.modal.querySelector('#slab-text-field-3');
        const textField4Input = this.modal.querySelector('#slab-text-field-4');
        const textField5Input = this.modal.querySelector('#slab-text-field-5');
        const textField6Input = this.modal.querySelector('#slab-text-field-6');
        
        if (textField1Input) {
            textField1Input.addEventListener('input', () => {
                this.slabData.textField1 = textField1Input.value;
                this.updateFrontPreview();
            });
        }
        
        if (textField2Input) {
            textField2Input.addEventListener('input', () => {
                this.slabData.textField2 = textField2Input.value;
                this.updateFrontPreview();
            });
        }
        
        if (textField3Input) {
            textField3Input.addEventListener('input', () => {
                this.slabData.textField3 = textField3Input.value;
                this.updateFrontPreview();
            });
        }
        
        if (textField4Input) {
            textField4Input.addEventListener('input', () => {
                this.slabData.textField4 = textField4Input.value;
                this.updateFrontPreview();
            });
        }
        
        if (textField5Input) {
            textField5Input.addEventListener('input', () => {
                this.slabData.textField5 = textField5Input.value;
                this.updateFrontPreview();
            });
        }
        
        if (textField6Input) {
            textField6Input.addEventListener('input', () => {
                this.slabData.textField6 = textField6Input.value;
                this.updateFrontPreview();
            });
        }
    }
    
    /**
     * Bind back side input events (now only for QR code toggle)
     */
    bindBackSideEvents() {
        // QR Code toggle
        const qrToggle = this.modal.querySelector('#slab-qr-enabled');
        const qrContentGroup = this.modal.querySelector('.stc-slab-qr-content-group');
        const qrPreviewContainer = this.modal.querySelector('.stc-slab-qr-preview');
        const qrContentInput = this.modal.querySelector('#slab-qr-content');
        
        if (qrToggle) {
            qrToggle.addEventListener('change', () => {
                const isEnabled = qrToggle.checked;
                this.slabData.backSide.qrEnabled = isEnabled;
                
                // Toggle visibility of content input and preview
                if (qrContentGroup) {
                    qrContentGroup.style.display = isEnabled ? '' : 'none';
                }
                
                if (qrPreviewContainer) {
                    qrPreviewContainer.style.display = isEnabled ? '' : 'none';
                }
                
                // Enable/disable QR content input
                if (qrContentInput) {
                    qrContentInput.disabled = !isEnabled;
                    
                    // If disabled, clear QR content
                    if (!isEnabled) {
                        qrContentInput.value = '';
                        this.slabData.backSide.qrContent = '';
                        this.slabData.backSide.qrDataUrl = null;
                        this.updateQRCode();
                    } else if (qrContentInput.value === '') {
                        // If enabled but empty, focus on input
                        qrContentInput.focus();
                    }
                }
                
                this.updateBackPreview();
            });
        }
        
        // QR Content Input
        if (qrContentInput) {
            qrContentInput.addEventListener('input', () => {
                this.slabData.backSide.qrContent = qrContentInput.value;
                this.updateQRCode();
                this.updateBackPreview();
                
                // We need to update the price any time QR content changes
                // This ensures that when user saves, the QR price is calculated
                if (this.slabData.backSide.qrEnabled) {
                    // This will be handled on save
                }
            });
        }
    }
    
    /**
     * Switch active tab
     * 
     * @param {string} tab - Tab to switch to ('front' or 'back')
     */
    switchTab(tab) {
        if (tab !== 'front' && tab !== 'back') return;
        
        this.activeTab = tab;
        
        // Update tab buttons
        this.modal.querySelectorAll('.stc-slab-tab').forEach(tabBtn => {
            tabBtn.classList.toggle('active', tabBtn.dataset.tab === tab);
        });
        
        // Update panels
        this.modal.querySelector('#stc-slab-front-panel').classList.toggle('active', tab === 'front');
        this.modal.querySelector('#stc-slab-back-panel').classList.toggle('active', tab === 'back');
        
        // Update preview for current tab
        this.updatePreview();
    }
    
    /**
     * Update preview based on current tab
     */
    updatePreview() {
        if (this.activeTab === 'front') {
            this.updateFrontPreview();
        } else {
            this.updateBackPreview();
        }
    }
    
    /**
     * Update front side preview
     */
    updateFrontPreview() {
        const textField1Preview = this.modal.querySelector('#preview-text-field-1');
        const textField2Preview = this.modal.querySelector('#preview-text-field-2');
        const textField3Preview = this.modal.querySelector('#preview-text-field-3');
        const textField4Preview = this.modal.querySelector('#preview-text-field-4');
        const textField5Preview = this.modal.querySelector('#preview-text-field-5');
        const textField6Preview = this.modal.querySelector('#preview-text-field-6');
        const barcodePreview = this.modal.querySelector('#preview-barcode');
        
        if (textField1Preview) {
            textField1Preview.textContent = this.slabData.textField1 || 'Jeff Gilbert';
        }
        
        if (textField2Preview) {
            textField2Preview.textContent = this.slabData.textField2 || 'Custom Card Lab';
        }
        
        if (textField3Preview) {
            textField3Preview.textContent = this.slabData.textField3 || 'Est 02-22-2025';
        }
        
        if (textField4Preview) {
            textField4Preview.textContent = this.slabData.textField4 || '#001';
        }
        
        if (textField5Preview) {
            textField5Preview.textContent = this.slabData.textField5 || 'GEM MT';
        }
        
        if (textField6Preview) {
            textField6Preview.textContent = this.slabData.textField6 || '10';
        }
        
        if (barcodePreview) {
            barcodePreview.innerHTML = this.generateBarcode('CCL001');
        }
    }
    
    /**
     * Update back side preview (now with static content and optional QR)
     */
    updateBackPreview() {
        // Back barcode is static but we still generate it
        const backBarcodePreview = this.modal.querySelector('#preview-back-barcode');
        if (backBarcodePreview) {
            backBarcodePreview.innerHTML = this.generateBarcode('CCL001');
        }
        
        // QR Code preview only if enabled
        const backQrPreview = this.modal.querySelector('#preview-back-qr');
        if (backQrPreview) {
            if (this.slabData.backSide.qrEnabled && this.slabData.backSide.qrDataUrl) {
                backQrPreview.innerHTML = `<img src="${this.slabData.backSide.qrDataUrl}" alt="QR Code">`;
            } else {
                backQrPreview.innerHTML = '';
            }
        }
    }
    
    /**
     * Update QR code in preview
     */
    async updateQRCode() {
        // If QR is not enabled, don't generate it
        if (!this.slabData.backSide.qrEnabled) {
            this.slabData.backSide.qrDataUrl = null;
            
            // Clear QR previews
            const qrPreview = this.modal.querySelector('#qr-preview');
            if (qrPreview) {
                qrPreview.innerHTML = `<div class="stc-slab-qr-placeholder">QR code will appear here</div>`;
            }
            
            const backQrPreview = this.modal.querySelector('#preview-back-qr');
            if (backQrPreview) {
                backQrPreview.innerHTML = '';
            }
            
            return;
        }
        
        const qrPreview = this.modal.querySelector('#qr-preview');
        if (!qrPreview) return;
        
        const qrContent = this.slabData.backSide.qrContent;
        
        if (!qrContent) {
            qrPreview.innerHTML = `<div class="stc-slab-qr-placeholder">QR code will appear here</div>`;
            return;
        }
        
        try {
            // Wait for QRCode library to be loaded
            await this.loadQRCodeLibrary();
            
            // Generate QR code
            const qrDataUrl = await QRCode.toDataURL(qrContent, {
                width: 128,
                margin: 0,
                color: {
                    dark: '#000000',
                    light: '#ffffff'
                }
            });
            
            // Store data URL
            this.slabData.backSide.qrDataUrl = qrDataUrl;
            
            // Update preview
            qrPreview.innerHTML = `<img src="${qrDataUrl}" alt="QR Code">`;
            
            // Also update QR preview in back side preview
            const backQrPreview = this.modal.querySelector('#preview-back-qr');
            if (backQrPreview) {
                backQrPreview.innerHTML = `<img src="${qrDataUrl}" alt="QR Code">`;
            }
            
        } catch (error) {
            console.error('Error generating QR code:', error);
            qrPreview.innerHTML = `<div class="stc-slab-qr-placeholder">Error generating QR code</div>`;
        }
    }
    
    /**
     * Generate a simple barcode representation
     * 
     * @param {string} input - Input string for barcode
     * @returns {string} HTML representation of barcode
     */
    generateBarcode(input) {
        // Using string hash to create "random" bar widths
        const hash = this.simpleHash(input || 'SAMPLE');
        
        let barcodeHTML = '';
        
        // Using hash to determine bar width
        for (let i = 0; i < 30; i++) {
            const width = ((hash * (i + 1)) % 4) + 1;
            barcodeHTML += `<div class="stc-barcode-line" style="width: ${width}px"></div>`;
        }
        
        return `<div class="stc-barcode-container">${barcodeHTML}</div>`;
    }
    
    /**
     * Simple string hash function
     * 
     * @param {string} str - Input string
     * @returns {number} - Hash value
     */
    simpleHash(str) {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = ((hash << 5) - hash) + str.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return Math.abs(hash);
    }
    
    /**
     * Set initial form data
     * 
     * @param {object} data - Initial slab data
     */
    setInitialData(data) {
        // Set front side data - map from old to new field names
        this.slabData.textField1 = data.name || data.textField1 || '';
        this.slabData.textField2 = data.company || data.textField2 || '';
        this.slabData.textField3 = data.date || data.textField3 || '';
        this.slabData.textField4 = data.serial || data.textField4 || '';
        this.slabData.textField5 = data.grade || data.textField5 || '';
        this.slabData.textField6 = data.gradeValue || data.textField6 || '';
        
        // Set back side data if available (only QR settings now)
        if (data.backSide) {
            // Only set QR-related options, everything else is static
            this.slabData.backSide.qrEnabled = data.backSide.qrEnabled || false;
            this.slabData.backSide.qrContent = data.backSide.qrContent || '';
            this.slabData.backSide.qrDataUrl = data.backSide.qrDataUrl || null;
        }
        
        // Set form values - Front Side
        const textField1Input = this.modal.querySelector('#slab-text-field-1');
        const textField2Input = this.modal.querySelector('#slab-text-field-2');
        const textField3Input = this.modal.querySelector('#slab-text-field-3');
        const textField4Input = this.modal.querySelector('#slab-text-field-4');
        const textField5Input = this.modal.querySelector('#slab-text-field-5');
        const textField6Input = this.modal.querySelector('#slab-text-field-6');
        
        if (textField1Input) textField1Input.value = this.slabData.textField1;
        if (textField2Input) textField2Input.value = this.slabData.textField2;
        if (textField3Input) textField3Input.value = this.slabData.textField3;
        if (textField4Input) textField4Input.value = this.slabData.textField4;
        if (textField5Input) textField5Input.value = this.slabData.textField5;
        if (textField6Input) textField6Input.value = this.slabData.textField6;
        
        // Set form values - Back Side (QR toggle and content)
        const qrToggle = this.modal.querySelector('#slab-qr-enabled');
        const qrContentInput = this.modal.querySelector('#slab-qr-content');
        const qrContentGroup = this.modal.querySelector('.stc-slab-qr-content-group');
        const qrPreviewContainer = this.modal.querySelector('.stc-slab-qr-preview');
        
        if (qrToggle) qrToggle.checked = this.slabData.backSide.qrEnabled;
        if (qrContentInput) qrContentInput.value = this.slabData.backSide.qrContent;
        
        // Show/hide QR content based on enabled state
        if (qrContentGroup) {
            qrContentGroup.style.display = this.slabData.backSide.qrEnabled ? '' : 'none';
        }
        
        if (qrPreviewContainer) {
            qrPreviewContainer.style.display = this.slabData.backSide.qrEnabled ? '' : 'none';
        }
        
        if (qrContentInput) {
            qrContentInput.disabled = !this.slabData.backSide.qrEnabled;
        }
        
        // Update previews
        this.updateFrontPreview();
        this.updateQRCode();
        this.updateBackPreview();
    }
    
    /**
     * Save data and notify listeners
     */
    saveData() {
        this.slabData.lastUpdated = Date.now();
    
        this.emit('save', this.slabData);
        
        // Also emit canvas event to update preview immediately
        const event = new CustomEvent('stc:slab:previewUpdate', {
            detail: this.slabData
        });
        document.dispatchEvent(event);
    }
    
    /**
     * Show the modal
     */
    show() {
        this.isVisible = true;
        this.modal.classList.add('is-active');
        this.emit('show');
    }
    
    /**
     * Hide the modal
     */
    hide() {
        this.isVisible = false;
        this.modal.classList.remove('is-active');
        this.emit('hide');
    }
    
    /**
     * Emit an event
     * 
     * @param {string} eventName - Event name
     * @param {object} detail - Event detail
     */
    emit(eventName, detail = {}) {
        const event = new CustomEvent(`stc:slab:${eventName}`, { detail });
        this.modal.dispatchEvent(event);    
    }

    /**
     * Listen for event
     * 
     * @param {string} eventName - Event name
     * @param {function} callback - Event callback
     */
    on(eventName, callback) {
        this.modal.addEventListener(`stc:slab:${eventName}`, callback);
    }

    /**
     * Remove event listener
     * 
     * @param {string} eventName - Event name
     * @param {function} callback - Event callback
     */
    off(eventName, callback) {
        this.modal.removeEventListener(`stc:slab:${eventName}`, callback);
    }
}